import { useCallback } from 'react';

import Card from '#globalComponents/Card/Card';
import Switch from '#globalComponents/Forms/Switch';
import { useAuth } from '#globalContexts/AuthProvider';
import { useSaveUserSettings } from '#settingsFeature/models/userSettings/mutations';
import { useUserSettings } from '#settingsFeature/models/userSettings/queries';

import { useIntegrationsList } from '../../../models/integrations/queries';

const CallingSettingsTab = () => {
	const { user } = useAuth();
	const userId = user?.id;
	const { data: settings } = useUserSettings();
	const save = useSaveUserSettings();

	const { data: integrations = [] } = useIntegrationsList();
	const isAircallConnected = integrations.find((i) => i.slug === 'phone_aircall')?.isConnected ?? false;

	const everywhereEnabled = settings?.userSettings?.aircallEverywhereEnabled === true;

	const handleToggle = useCallback(() => {
		const updated = {
			...(settings?.userSettings ?? {}),
			aircallEverywhereEnabled: !everywhereEnabled,
		};
		save.mutate({ id: userId, updates: { userSettings: updated } });
	}, [userId, settings, everywhereEnabled, save]);

	return (
		<div className="space-y-6">
			<div>
				<h2 className="text-lg font-semibold text-text mb-1">Anruf-Einstellungen</h2>
				<p className="text-sm text-bgBase-800">Konfiguriere, wie Anrufe im CRM gestartet werden.</p>
			</div>

			<Card className="p-0 divide-y divide-bgBase-500">
				<div className="flex items-center justify-between px-5 py-4">
					<div>
						<div className="text-sm font-medium text-text">Aircall im Browser verwenden</div>
						<div className="text-xs text-bgBase-800 mt-0.5">
							{isAircallConnected
								? 'Wenn aktiviert, werden Anrufe direkt im Browser über Aircall Everywhere geführt. Andernfalls wird die Aircall Desktop-App verwendet.'
								: 'Verbinde zuerst Aircall unter Integrationen, um diese Option nutzen zu können.'}
						</div>
					</div>
					<Switch
						checked={everywhereEnabled}
						onChange={handleToggle}
						disabled={save.isPending || !isAircallConnected}
					/>
				</div>
			</Card>
		</div>
	);
};

export default CallingSettingsTab;
